<script>
  import Modal from './Modal.svelte';
  import { requestLogin, refreshBalance } from '../utils/authSession';
  import { publishImage, canPublish, shareUrl } from '../utils/communityApi';
  import { request } from '../utils/request';
  export let image = '';
  export let feature = '';
  export let options = {};
  let open = false;
  let busy = false;
  let error = '';
  let published = null;
  let rewardMessage = '';
  $: if (image) { published = null; rewardMessage = ''; }
  async function publish() {
    if (busy) return;
    busy = true; error = '';
    try {
      if (!await requestLogin('작품을 커뮤니티에 공유하려면 로그인해 주세요.')) return;
      const result = await publishImage({ image_url: image, feature, style: options?.style || options?.selectedStyle || 'E-RION 작품', style_backend: options?.style_backend || options?.selectedStyleBackend });
      published = result.item;
      try {
        const reward = await request('/api/daily_style_challenge/claim', { method: 'POST', body: { feed_image_id: published.id } });
        rewardMessage = reward.reward_amount ? `오늘의 챌린지 보상 ${reward.reward_amount} RION을 받았어요.` : '';
        await refreshBalance();
      } catch { /* Non-challenge artwork is still published successfully. */ }
    } catch (e) { error = e.message; } finally { busy = false; }
  }
</script>
{#if image && canPublish(feature, options || {})}
  <button type="button" class="publish" on:click={() => { open = true; error = ''; }}>커뮤니티에 공유</button>
{/if}
{#if open}
  <Modal label="커뮤니티 공유" closable={!busy} on:close={() => open = false}>
    <div class="publish-content">
      <h2>{published ? '커뮤니티에 공유했어요' : '작품을 공개할까요?'}</h2>
      <img src={image} alt="공유할 작품" />
      {#if published}
        <p>{rewardMessage}</p><a href={shareUrl(published)} target="_blank" rel="noreferrer">공유한 작품 보기</a>
      {:else}
        <p>이미지와 닉네임이 다른 사용자에게 공개됩니다. 내 게시물에서 공개를 취소할 수 있어요.</p>
        <button type="button" on:click={publish} disabled={busy}>{busy ? '공유 중...' : '공개하기'}</button>
      {/if}
      {#if error}<p role="alert">{error}</p>{/if}
    </div>
  </Modal>
{/if}
<style>
  button, a { padding: 9px 16px; border: 1px solid #fe6a37; border-radius: 10px; background: transparent; color: #e3612d; cursor: pointer; font: inherit; }
  .publish-content { display: grid; gap: 14px; text-align: center; } img { max-height: 50dvh; max-width: 100%; margin: auto; border-radius: 12px; } p { line-height: 1.7; } [role=alert] { color: #ca392d; }
</style>
